const fetchAccountGroupPermissionsUseCase = (repository) => async (id) => {
  return await repository(id)
}

export default fetchAccountGroupPermissionsUseCase